module.exports = __webpack_public_path__ + "static/media/filename (15).f8defcd5.png";